export default __webpack_public_path__ + "static/media/building.ba48e30c.jpg";